export const cardData2 = [
  {
    title: "3-Way Handshake",
    subtitle: "TCP Connection Setup",
    filepath: "/networking/3-way-handshake.md",
    content:
      "Understand how a TCP connection is established between client and server using the SYN, SYN-ACK, and ACK steps.",
  },
  {
    title: "DNS",
    subtitle: "Domain Name System",
    filepath: "/networking/dns.md",
    content:
      "Learn how DNS translates human-readable domain names into machine-readable IP addresses in networking.",
  },
  {
    title: "IP Address",
    subtitle: "IPv4 and IPv6 Explained",
    filepath: "/networking/ipadress.md",
    content:
      "Explore how IP addresses uniquely identify devices on a network and the differences between IPv4 and IPv6.",
  },
  {
    title: "Subnet Mask",
    subtitle: "IP Subnetting",
    filepath: "/networking/subnet.md",
    content:
      "Understand how subnet masks help divide IP networks into smaller, manageable sub-networks (subnets).",
  },
  {
    title: "TCP/IP Model",
    subtitle: "Internet Communication Layers",
    filepath: "/networking/tcp-ip.md",
    content:
      "Break down the four layers of the TCP/IP model: Application, Transport, Internet, and Network Access.",
  },
  {
    title: "Protocols",
    subtitle: "some famous protocols",
    filepath: "/networking/protocols.md",
    content:
      "Break down the four layers of the TCP/IP model: Application, Transport, Internet, and Network Access.",
  },
  {
    title: "Subenet",
    subtitle: "some famous protocols",
    filepath: "/networking/subnet.md",
    content:
      "Break down the four layers of the TCP/IP model: Application, Transport, Internet, and Network Access.",
  },
  {
    title: "how is subnetting done",
    subtitle: "some famous protocols",
    filepath: "/networking/subnetting.md",
    content:
      "Break down the four layers of the TCP/IP model: Application, Transport, Internet, and Network Access.",
  },
  {
    title: "ip routing and nat",
    subtitle: "some famous protocols",
    filepath: "/networking/ip-routing-nat.md",
    content:
      "Break down the four layers of the TCP/IP model: Application, Transport, Internet, and Network Access.",
  },
];
